import gql from "graphql-tag";

export const ROLES = gql`
  query Roles {
    roles {
      id
      name
    }
  }
`;
